module.exports = require("./kde.js");